import { DomainIpItem } from '@nirvana/shared/dtos/types/policies/common';
import { ColumnKeys } from '../gridComponents/antiSpoofing/grid-config';
import {
  compareNumbers,
  compareStrings,
} from '../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';

export function sortByColumn(item1: DomainIpItem, item2: DomainIpItem, columnName: string, direction: string): number {
  switch (columnName) {
    case ColumnKeys.DOMAIN:
      return compareStrings(item1.domain, item2.domain, direction);

    case ColumnKeys.IPS_COUNT:
      return compareNumbers(item1.ipsCount, item2.ipsCount, direction);

    case ColumnKeys.IP_MASK:
      return compareStrings(item1.ipsString, item2.ipsString, direction);
  }

  return 0;
}
